import { Image } from "@frontend/core";
import { MetaText } from "../metaText.model";

export class ProcessStep {
   constructor(
    public metaText: MetaText, // we'll use weight and num for numbering the steps; (may include icon)
    public images?: Image[],
    public subtitleText?: string, // 'some interesting words'
    public subtitleTranslationKey?: string, // 'tracking.accredited_until'
    public date?: Date,
    public divClasses?: string, // 'bg-success text-white'
    ){}
  }